<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemLog',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-log-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="操作日期">
                <a-range-picker v-model:value="operationDate" format="YYYY-MM-DD" :disabled-date="disabledDate" @calendar-change="onCalendarChange" @change="onDateChange" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="操作页面">
                <a-input v-model:value="state.tableData.param.pageName" placeholder="请输入操作页面名称" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="人员ID/姓名">
                <a-input v-model:value="state.tableData.param.user" placeholder="请输入人员ID/姓名" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary"><SearchOutlined />查询</ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary"><RedoOutlined />重置</ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading" :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog(record)">查看</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination
        v-model:current="state.tableData.param.pageNum"
        v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total"
        :page-size-options="['10', '20']"
        show-size-changer
        :show-total="(total) => `共 ${total} 条`"
        :showQuickJumper="true"
        @change="onPageChange"
        @show-size-change="onShowSizeChange"
      />
    </a-card>
    <LogDialog ref="LogDialogFormRef" />
  </div>
</template>

<script setup lang="ts" name="systemLog">
import { reactive, ref, onMounted, h } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import dayjs from 'dayjs'
import { useLog } from '@/store/system/log'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
const logStore = useLog()
import LogDialog from './dialog.vue'

const LogDialogFormRef = ref()

const columns = [
  { title: '操作时间', dataIndex: 'createTime', key: 'createTime', minWidth: 160, ellipsis: true },
  { title: '人员ID', dataIndex: 'createBy', key: 'createBy', ellipsis: true },
  { title: '姓名', dataIndex: 'userFullName', key: 'userFullName', ellipsis: true },
  { title: '操作模块', dataIndex: 'moduleName', key: 'moduleName', ellipsis: true },
  { title: '操作页面', dataIndex: 'pageName', key: 'pageName', ellipsis: true },
  { title: '操作类型', dataIndex: 'opType', key: 'opType', ellipsis: true },
  { title: '请求地址', dataIndex: 'pageUrl', key: 'pageUrl', ellipsis: true },
  { title: '操作', key: 'action', width: 150 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      startDate: '',
      endDate: '',
      pageName: '',
      user: ''
    }
  }
})

const operationDate = ref<any[]>([])
const pickedDate = ref<any>(null)

const getMonthRange = (date: any) => {
  const minDate = dayjs(date).subtract(1, 'month')
  const maxDate = dayjs(date).add(1, 'month')
  return { minDate: minDate.toDate(), maxDate: maxDate.toDate() }
}

const disabledDate = (current: any) => {
  if (!pickedDate.value) return false
  const { minDate, maxDate } = getMonthRange(pickedDate.value)
  return current.valueOf() < minDate.getTime() || current.valueOf() > maxDate.getTime()
}

const onCalendarChange = (dates: any[]) => {
  if (dates?.[0] && !dates?.[1]) {
    pickedDate.value = dates[0]
  } else {
    pickedDate.value = null
  }
}

const onDateChange = () => {
  pickedDate.value = null
  state.tableData.param.startDate = operationDate.value?.[0] ? dayjs(operationDate.value[0]).format('YYYY-MM-DD') : ''
  state.tableData.param.endDate = operationDate.value?.[1] ? dayjs(operationDate.value[1]).format('YYYY-MM-DD') : ''
}

const resetFun = () => {
  state.tableData.param.startDate = ''
  state.tableData.param.endDate = ''
  state.tableData.param.pageName = ''
  state.tableData.param.user = ''
  state.tableData.param.pageNum = 1
  operationDate.value = []
  pickedDate.value = null
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => logStore.getLogPage(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (row: any) => {
  logStore.getLogInfo({ id: row.id }).then((data: any) => {
    LogDialogFormRef.value.openDialog(data)
  })
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '此操作将永久删除该条操作日志，是否继续?',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return logStore.deleteLogInfo(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(() => {
  getTableData()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
